module.exports = __webpack_public_path__ + "static/media/HCMM458.814f70a0.jpg";